import { render, staticRenderFns } from "./ReClientAddress.vue?vue&type=template&id=06e11236&scoped=true"
import script from "./ReClientAddress.vue?vue&type=script&lang=js"
export * from "./ReClientAddress.vue?vue&type=script&lang=js"
import style0 from "./ReClientAddress.vue?vue&type=style&index=0&id=06e11236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e11236",
  null
  
)

export default component.exports